import React from 'react'
import Showcase from './Showcase'
import { makeStyles, Typography } from '@material-ui/core'

const useStyle = makeStyles((theme) => ({
    titleSearcher: {
        color: "#232323",
        fontWeight: "bold",
        fontSize: "2.5rem",
        marginTop: "1rem",
        [theme.breakpoints.down('md')]: {
            fontSize: "2rem"
        }
    }
}))

const Rent = () => {
    const classes = useStyle()
    
    const opParam = 'Alquiler'
    const tyParam = 'empty'
    const ubParam = 'empty'

    return (
        <div>
            <Typography align="center" className={classes.titleSearcher}>Alquileres</Typography>
            <Showcase op={opParam} ty={tyParam} ub={ubParam} />
        </div>
    )
}

export default Rent
